export enum ElementType {
  TEXT_ELEMENT,
  IMAGE_ELEMENT,
  VIDEO_ELEMENT,
  BACKGROUND_ELEMENT,
  GRAPH_ELEMENT,
  TABLE_ELEMENT,
}
